



























































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import * as firebase from 'firebase/app';
import { COLLECTION_ROLES, COLLECTION_USERS } from '@/model/AppConstants';
import StateType from '@/model/typelist/StateType';
import CityType from '@/model/typelist/CityType';
import FirebaseUtil from '@/model/FirebaseUtil';
import User from '@/model/User';
import { Cropper } from 'vue-advanced-cropper'
import PermUtil from '@/model/PermUtil';
import PostView from './PostView.vue';
import Aboutview from './About.vue';
import Settings from './Settings.vue';
import UserFriends from './UserFriends.vue';
// import 'cropperjs/dist/cropper.css';
@Component({
  components: {
    PostView,
    Aboutview,
    Settings,
    UserFriends,
    Cropper,
  },
})
export default class ViewUserProfileComp extends Vue {
  time = new Date();

  loading = false;

  tabs = null;

  items = ['Posts', 'About', 'Friends', 'Settings'];

  posts = [];

  editedIndex = -1;

  organizations = [];

  dateOfBirth = new Date().toISOString().substr(0, 10);

  menu = false;

  dialog = false;

  photoURL = '';

  backPhotoURL = '';

  cropBgImg = '';

  cropProfileImg = '';

  file = {} as any;

  backFile = {} as any;

  $refs!: {
    fileInput: HTMLFormElement;
    backFileInput: HTMLFormElement;
    cropper: HTMLFormElement;
    cropper1: HTMLFormElement;
  };

  mounted() {
    // this.$store.dispatch('findUserProfile', this.$route.params.id);
    this.$store.dispatch('bindRecived');
    this.$store.dispatch('bindRequest');
    this.$store.dispatch('bindFriends');
  }
  // eslint-disable-next-line
  get viewSet() {
    if (PermUtil.canViewSettings()) {
      return '';
    }
    return 'Settings';
  }

  get isFrnd() {
    if (this.$store.state.friends.find((frnd: any) => (frnd.uid === this.userProfileView.uid))) {
      return true;
    }
    if (this.$store.state.requests.find((frnd: any) => (frnd.uid === this.userProfileView.uid))) {
      return true;
    }
    if (this.$store.state.reciveds.find((frnd: any) => (frnd.uid === this.userProfileView.uid))) {
      return true;
    }
    return false;
  }

  pickFile() {
    this.$refs.fileInput.click();
  }

  pickBackFile() {
    this.$refs.backFileInput.click();
  }

  cropPhoto() {
    this.cropProfileImg = this.$refs.cropper.getResult().canvas.toDataURL();
  }

  cropCoverPhoto() {
    this.cropBgImg = this.$refs.cropper1.getResult().canvas.toDataURL();
  }

  onFilePick(event: any) {
    [this.file] = event.target.files;
    const fr = new FileReader();
    fr.onload = () => {
      this.photoURL = fr.result as string;
    };
    fr.readAsDataURL(this.file);
  }

  onPick(event: any) {
    [this.backFile] = event.target.files;
    const fr = new FileReader();
    fr.onload = () => {
      this.backPhotoURL = fr.result as string;
    };
    fr.readAsDataURL(this.backFile);
  }

  form = { ...this.userProfileView };

  async parsedUser() {
    const clone = { ...this.userProfileView };
    if (this.file.name) {
      await this.loadImage(clone.id, this.file, this.cropProfileImg).then((result: any) => {
        clone.photoURL = result;
      });
    }
    if (this.backFile.name) {
      await this.loadImage(clone.id, this.backFile, this.cropBgImg).then((result: any) => {
        clone.backPhotoURL = result;
      });
    }
    const cloneList = [] as any;
    clone.roles.forEach((role: any) => {
      cloneList.push(FirebaseUtil.ObjectToRef(COLLECTION_ROLES, role.id));
    });
    clone.roles = cloneList;
    clone.state = { ...this.form.state }
    clone.city = { ...this.form.city }
    return clone;
  }

  async UpdateUser() {
    this.loading = true;
    await this.$store.dispatch('updateCollection', {
      collection: COLLECTION_USERS,
      doc: this.userProfileView.uid,
      payload: await this.parsedUser(),
    });
    this.$router.push('/').catch();
    this.close();
  }
  // eslint-disable-next-line
  async loadImage(id: string, file: any, url: string) {
    let imgUrl = '';
    const promise = await new Promise((resolve: any) => {
      const profileImageRef = firebase
        .storage()
        .ref()
        .child(`${id}/${file.name}`);
      profileImageRef.putString(url, 'data_url').then(() => {
        profileImageRef.getDownloadURL().then((downloadURL: any) => {
          imgUrl = downloadURL;
          resolve();
        });
      });
    });
    return imgUrl;
  }

  close() {
    this.dialog = false;
    this.form.fullname = '';
    this.form.organizations = '';
    this.dialog = false;
    this.file = {};
    this.backFile = {};
    this.backPhotoURL = '';
    this.photoURL = '';
    this.loading = false;
  }

  editProfile() {
    this.dialog = true;
  }
  // eslint-disable-next-line
  get states() {
    return StateType.allStates();
  }

  get cities() {
    if (this.form.state) {
      return CityType.allCities()
        .filter((city: any) => city.stateType.code === this.form.state.code);
    }
    return [];
  }

  sendRequests(user: any) {
    this.$store.dispatch('sendRequests', {
      collection: 'users',
      doc: {
        uid: this.currentUser.uid,
      },
      sendRequests: 'sendRequests',
      RecivedRequests: 'RecivedRequests',
      payload: {
        uid: user.uid,
      },
    });
  }

  get userProfileView() {
    if (this.$store.state.profileUser === null) {
      return {};
    }
    return this.$store.state.profileUser;
  }

  get currentUser() {
    return this.$store.state.freshCurrentUser;
  }

  phoneRules = [
    (v: any) => (v || '').length === 10 || 'Phone number should be 10 digits long',
    (v: any) => !!Number(v) || 'Phone number should be digits only',
  ];
}
